<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item>
              <a-tree-select
                v-model="queryParam.catId"
                placeholder='请选择商品类别'
                treeDefaultExpandAll
                :treeData="categoryData"
              >
              </a-tree-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item>
              <a-input placeholder="输入商品编号/名称/规格型号等查询" v-model="queryParam.kw"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="状态">
              <a-select placeholder="请选择" default-value="" v-model="queryParam.status">
                <a-select-option value="">全部</a-select-option>
                <a-select-option value="active">启用</a-select-option>
                <a-select-option value="deleted">禁用</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="tableSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="resetTableSearch">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="handleAdd">新增</a-button>
      <a-button type="default" icon="reload" @click="reloadTable">刷新</a-button>
    </div>

    <s-table
      size="default"
      ref="table"
      :pageSize=20
      :columns="columns"
      :data="loadData"
      bordered
    >
      <span slot="status" slot-scope="text, record">
        <a-switch checkedChildren="启用" unCheckedChildren="禁用" defaultChecked v-if="record.status == 'active'" @change="statusChange($event, record)"/>
        <a-switch checkedChildren="启用" unCheckedChildren="禁用" v-else  @change="statusChange($event, record)"/>
      </span>
      <span slot="categoryName" slot-scope="text, record">
        <span v-if="record.category">{{ record.category.name }}</span>
      </span>

      <span slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">编辑</a>
        <a-divider type="vertical" />
        <a-dropdown>
          <a class="ant-dropdown-link">
            更多 <a-icon type="down" />
          </a>
          <a-menu slot="overlay">
            <a-menu-item>
              <a-popconfirm placement="topLeft" title="确定要删除此商品吗?删除后无法恢复！" @confirm="deleteConfirm(record.id)" okText="确定" cancelText="取消">
                <a href="#">删除</a>
              </a-popconfirm>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </span>
    </s-table>
    <GoodsForm
      :isEditForm="isEditForm"
      :title="title"
      :visible="visible"
      :formdata="selectrow"
      @formcancel="formcancel"
      @formsuccess="formsuccess"></GoodsForm>
  </a-card>
</template>
<script>
import STable from '@/components/table/'
import GoodsForm from '@/components/Goods/Form'
import { getGoodsList, editGoods, deleteGoods } from '@/api/goods'
import { getCategoryGoods } from '@/api/category'
import { CODE_FAIL } from '@/store/mutation-types'
export default {
  name: 'SettingsGoodsList',
  components: {
    STable,
    GoodsForm
  },
  data () {
    return {
      visible: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      form: this.$form.createForm(this),
      isEditForm: false,
      title: '新增商品',
      selectrow: {},

      // 查询参数
      queryParam: {
        kw: '',
        catId: '0',
        status: ''
      },
      categoryData: null,
      // 表头
      columns: [
        {
          title: '商品编号',
          dataIndex: 'locationNo',
          className: 'text-center'
        },
        {
          title: '商品名称',
          dataIndex: 'name',
          className: 'text-center'
        },
        {
          title: '商品类别',
          dataIndex: 'category.name',
          className: 'text-center',
          scopedSlots: { customRender: 'categoryName' }
        },
        {
          title: '规格型号',
          dataIndex: 'type',
          className: 'text-center'
        },
        {
          title: '单位',
          dataIndex: 'unit.name',
          className: 'text-center'
        },
        {
          title: '当前库存',
          dataIndex: 'totalNums',
          className: 'text-right'
        },
        {
          title: '备注',
          dataIndex: 'note'
        },
        {
          title: '状态',
          dataIndex: 'status',
          className: 'text-center',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '操作',
          width: '150px',
          dataIndex: 'action',
          className: 'text-center',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return getGoodsList(Object.assign(parameter, this.queryParam))
          .then(res => {
            return res.result
          })
      },

      selectedRowKeys: [],
      selectedRows: []
    }
  },
  created () {
    this.loadCategory()
  },
  methods: {
    formcancel () {
      this.visible = false
    },
    formsuccess (values) {
      this.visible = false
      this.reloadTable()
    },
    handleEdit (record) {
      this.selectrow = Object.assign({}, record)
      console.log('商品被选中项', this.selectrow)
      this.title = '编辑商品资料'
      this.isEditForm = true
      this.visible = true
    },
    handleAdd () {
      this.selectrow = {
      }
      this.title = '新增商品'
      this.isEditForm = false
      this.visible = true
    },

    reloadTable () {
      this.$refs.table.refresh(true)
    },
    tableSearch () {
      this.$refs.table.refresh(true)
    },
    resetTableSearch () {
      this.queryParam = {
        kw: '',
        catId: '0',
        status: ''
      }
      this.reloadTable()
    },
    statusChange (event, record) {
      const data = record
      data.status = event === true ? 'active' : 'deleted'
      editGoods(data).then(res => {
        if (res.status !== CODE_FAIL) {
          this.$message.success('修改成功')
        } else {
          this.$message.error(res.message)
        }
      })
    },
    loadCategory () {
      getCategoryGoods({ tree: true })
        .then(res => {
          this.categoryData = res.result
        })
    },
    deleteConfirm (id) {
      deleteGoods({ id: id }).then((res) => {
        if (res.status !== CODE_FAIL) {
          this.$message.success('删除成功')
          this.reloadTable()
        } else {
          this.$message.error(res.message)
        }
      })
    }
  },
  watch: {
  }
}
</script>
<style>

  th.text-right, td.text-right {
    text-align: right !important;
  }
  th.text-center, td.text-center {
    text-align: center !important;
  }
</style>
